module.exports = __webpack_public_path__ + "static/img/contant_1.7e19e91.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/contant_1.jpeg
// module id = kNF2
// module chunks = 0